"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubmissionLogKey = exports.SubmissionSchema = void 0;
exports.SubmissionSchema = {
    type: 'object',
    required: [],
    properties: {},
};
exports.getSubmissionLogKey = function (submission) {
    return submission.submissionID;
};
